<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-web-service') }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-1">
                          <!-- <p>
                                {{SearchResult}}
                            </p> -->
                            <div class="col-sm-12">
                                  <hr>
                                    <div class="text-center p-5" v-if="loading">
                                        <div class="spinner-border text-secondary" role="status" v-if="loading">
                                        <span class="sr-only"><p>{{ $t('website.website-service-detail') }}</p></span>
                                    </div>
                                </div>
                                 <p v-if="webService.domain_name"><b>{{ $t('website.domain_name') }} : </b> {{webService.domain_name}}</p>
                                 <p v-if="webService.ftp"><b>FTP (Port : 21 ) : </b><span v-if="webService.ftp == 'Open'" class="text-success"> {{webService.ftp}}</span><span v-else> {{webService.ftp}}</span></p>
                                  <p v-if="webService.ssh"><b>SSH ( Port : 22 ) : </b> <span v-if="webService.ssh == 'Open'" class="text-success"> {{webService.ssh}}</span><span v-else> {{webService.ssh}}</span></p>
                                  <p v-if="webService.dns"><b>Telnet ( Port : 23 ) : </b> <span v-if="webService.telnet == 'Open'" class="text-success"> {{webService.telnet}}</span><span v-else> {{webService.telnet}}</span></p>
                                  <p v-if="webService.smtp"><b>SMTP ( Port :25 ) : </b> <span v-if="webService.smtp == 'Open'" class="text-success"> {{webService.smtp}}</span><span v-else> {{webService.smtp}}</span></p>
                                  <p v-if="webService.whois"><b>WHOIS ( Port : 43 ) : </b> <span v-if="webService.whois == 'Open'" class="text-success"> {{webService.whois}}</span><span v-else> {{webService.whois}}</span></p>
                                  <p v-if="webService.dns"><b>DNS ( Port : 53 ) : </b><span v-if="webService.dns == 'Open'" class="text-success"> {{webService.dns}}</span><span v-else> {{webService.dns}}</span></p>
                                  <p v-if="webService.dhcp"><b>DHCP ( Port : 68 ) : </b> <span v-if="webService.dhcp == 'Open'" class="text-success"> {{webService.dhcp}}</span><span v-else> {{webService.dhcp}}</span></p>
                                  <p v-if="webService.http"><b>HTTP ( Port : 80 ) : </b> <span v-if="webService.http == 'Open'" class="text-success"> {{webService.http}}</span><span v-else> {{webService.http}}</span></p>
                                  <p v-if="webService.pop3"><b>POP3 ( Port : 110 ) : </b> <span v-if="webService.pop3 == 'Open'" class="text-success"> {{webService.pop3}}</span><span v-else> {{webService.pop3}}</span></p>
                                  <p v-if="webService.sftp"><b>SFTP ( Port : 115 ) : </b><span v-if="webService.sftp == 'Open'" class="text-success"> {{webService.sftp}}</span><span v-else> {{webService.sftp}}</span></p>
                                  <p v-if="webService.nntp"><b>NNTP ( Port : 119 ) : </b> <span v-if="webService.nntp == 'Open'" class="text-success"> {{webService.nntp}}</span><span v-else> {{webService.nntp}}</span></p>
                                  <p v-if="webService.ntp"><b>NTP ( Port : 123 ) : </b> <span v-if="webService.ntp == 'Open'" class="text-success"> {{webService.ntp}}</span><span v-else> {{webService.ntp}}</span></p>
                                  <p v-if="webService.netbios"><b>NETBIOS ( Port : 139 ) : </b><span v-if="webService.netbios == 'Open'" class="text-success"> {{webService.netbios}}</span><span v-else> {{webService.netbios}}</span></p>
                                  <p v-if="webService.imap"><b>IMAP ( Port : 143 ) : </b><span v-if="webService.imap == 'Open'" class="text-success"> {{webService.imap}}</span><span v-else> {{webService.imap}}</span></p>
                                  <p v-if="webService.snmp"><b>SNMP ( Port : 161 ) : </b><span v-if="webService.snmp == 'Open'" class="text-success"> {{webService.snmp}}</span><span v-else> {{webService.snmp}}</span></p>
                                  <p v-if="webService.imap3"><b>IMAP3 ( Port : 220 ) : </b> <span v-if="webService.imap3 == 'Open'" class="text-success"> {{webService.imap3}}</span><span v-else> {{webService.imap3}}</span></p>
                                  <p v-if="webService.idap"><b>IDAP ( Port : 389 ) : </b><span v-if="webService.idap == 'Open'" class="text-success"> {{webService.idap}}</span><span v-else> {{webService.idap}}</span></p>
                                  <p v-if="webService.ssl"><b>SSL ( Port : 443 ) : </b> <span v-if="webService.ssl == 'Open'" class="text-success"> {{webService.ssl}}</span><span v-else> {{webService.ssl}}</span></p>
                                  <p v-if="webService.oracle_sql"><b>ORACLE SQL ( Port : 1521 ) : </b> <span v-if="webService.oracle_sql == 'Open'" class="text-success"> {{webService.oracle_sql}}</span><span v-else> {{webService.oracle_sql}}</span></p>
                                  <p v-if="webService.nfs"><b>NFS ( Port : 2049 ) : </b> <span v-if="webService.nfs == 'Open'" class="text-success"> {{webService.nfs}}</span><span v-else> {{webService.nfs}}</span></p>
                                  <p v-if="webService.mysql"><b>MYSQL ( Port : 3306 ) : </b> <span v-if="webService.mysql == 'Open'" class="text-success"> {{webService.mysql}}</span><span v-else> {{webService.mysql}}</span></p>
                                  <p v-if="webService.vnc"><b>VNC ( Port : 5800 ) : </b> <span v-if="webService.vnc == 'Open' " class="text-success"> {{webService.vnc}}</span><span v-else> {{webService.vnc}}</span></p>
                                  <p v-if="webService.http2"><b>HTTP2 ( Port : 8080 ) : </b> <span v-if="webService.http2 == 'Open'" class="text-success"> {{webService.http2}}</span><span v-else> {{webService.http2}}</span></p>
                            </div>
                        </div>
                    </div>
                  </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: "/web-service",
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            webService: {
            },
            search:false,
            title: this.$t('website.website-web-service-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-web-service'),
                href: "/web-service"
                },
                {
                text: this.$t('website.website-web-service-detail'),
                active: true
                }
            ],
        }
    },
    methods:{
        getWebServices(){
            this.loading = true;
            WebsiteService.getWebServicesDetail(this.id)
            .then(response => {
                    // console.log(response);
                    this.webService = response.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = flase;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getWebServices();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>